// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"04c728d2","513":"844fba3d","787":"71e672d5"}[chunkId] + ".chunk.js";
};